<div class="container">

  <!-- Breadcrumb -->
  <div class="dashboard_bred_crumb">
    <ul>
      <li>
        <img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt="">
      </li>
      <li>
        <a [routerLink]="['/profile/partnership-request']" routerLinkActive="active-link">Partnership Requests</a>
      </li>
    </ul>
  </div>

  <!-- Card Wrapper -->
  <div class="bg-white p-3" style="border-radius: 10px;">

    <!-- Tabs -->
    <div class="custom-tabs">
      <mat-button-toggle-group
        class="horizontal-toggle-buttons tabs-button-group"
        [value]="selectedTabStatus"
        exclusive
        style="width: 100%;"
        (change)="onTabChange($event.value, $event.source.selected?.index)"
      >
        <mat-button-toggle value="ALL">All</mat-button-toggle>
        <mat-button-toggle value="Partnership Request">Partnership Request</mat-button-toggle>
        <mat-button-toggle value="PENDING">Pending</mat-button-toggle>
        <mat-button-toggle value="APPROVED">Approved</mat-button-toggle>
        <mat-button-toggle value="REJECTED">Rejected</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Table -->
    <div class="table-container">
      <table class="table custom-table mb-0">
        <thead>
          <tr>
            <th class="sno-col">S.No</th>
            <th class="company-col">Company Name</th>
            <th class="contact-col">Contact Name</th>
            <th class="email-col">Email</th>
            <th class="phone-col">Phone</th>
            <th class="status-col">Status</th>
            <th class="action-col">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let partner of filteredPartners; let i = index">
            <td class="sno-col">{{ i + 1 }}</td>
            <td class="text-truncate company-col" matTooltip="{{ partner.company_name }}">
              {{ partner.company_name || '-' }}
            </td>
            <td class="text-truncate contact-col" matTooltip="{{ partner.contact_name }}">
              {{ partner.contact_name || '-' }}
            </td>
            <td class="text-truncate email-col" matTooltip="{{ partner.email }}">
              {{ partner.email || '-' }}
            </td>
            <td class="text-truncate phone-col" matTooltip="{{ partner.phone }}">
              {{ partner.phone || '-' }}
            </td>
            <td class="text-truncate status-col">
              {{ partner.status || '-' }}
            </td>

            <!-- <td class="action-col">
              <button
                *ngIf="partner.status === 'PENDING' || partner.status === 'REJECTED'"
                mat-raised-button color="primary" class="mr-2 btn-sm"
                (click)="updateStatus(partner, 'APPROVED')"
              >
                Approve
              </button>

              <button
                *ngIf="partner.status === 'PENDING' || partner.status === 'APPROVED'"
                mat-raised-button color="warn" class="btn-sm"
                (click)="updateStatus(partner, 'REJECTED')"
              >
                Reject
              </button>
            </td> -->
               <!-- Actions column with 3-dot menu -->
            <td class="action-col">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Actions"
                class="action-menu-btn"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngIf="partner.status === 'PENDING' || partner.status === 'REJECTED'"
                  (click)="updateStatus(partner, 'APPROVED')"
                >
                  <mat-icon color="primary">check_circle</mat-icon>
                  <span>Approve</span>
                </button>

                <button
                  mat-menu-item
                  *ngIf="partner.status === 'PENDING' || partner.status === 'APPROVED'"
                  (click)="updateStatus(partner, 'REJECTED')"
                >
                  <mat-icon color="warn">cancel</mat-icon>
                  <span>Reject</span>
                </button>
              </mat-menu>
            </td>

          </tr>

          <!-- No Data -->
          <tr *ngIf="!loading && filteredPartners.length === 0">
            <td colspan="7" class="text-center py-3">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center p-3">
      Loading Partnership Requests...
    </div>

    <!-- Paginator -->
    <div class="custom-paginator">
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20, 50]"
        showFirstLastButtons="false"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>

  </div>
</div>
